import { useContext } from 'react';
import { FocusTimeContext } from './FocusTimeProvider';

const useFocusTimeSlots = () => {
  const context = useContext(FocusTimeContext);

  if (!context) {
    throw new Error('useFocusTimeSlots must be used inside FocusTimeProvider');
  }

  return context;
};

export default useFocusTimeSlots;
